export const BASE_PRICE_PER_HOUR = '28'
export const PREFIX_BASE_PRICE_PER_HOUR = 'ab'
